import { TaxonomyEducationAndSeniorityLevel } from '@vonq/hapi-elements-types';
import React from 'react';
import { Select, SelectOption } from '../../../../../components/Select';
import { TargetGroupValues, JobPostingDetailsForm } from './index';
import { FormGroup } from './FormGroup';
import {
  multiLangTargetGroupFromOption,
  targetGroupFromOption,
} from './target_group_utils';

interface PropTypes {
  targetGroupValues: TargetGroupValues;
  form: JobPostingDetailsForm;
  onInputChange: (name: string, value: unknown) => void;
}

export function TargetGroup(props: PropTypes) {
  return (
    <FormGroup>
      <h4>Target Group</h4>
      <MultiLangTargetGroupSelect
        name={'educationLevel'}
        label='Education Level'
        values={props.targetGroupValues?.educationLevels}
        selected={props.form.educationLevel}
        onInputChange={props.onInputChange}
      />
      <MultiLangTargetGroupSelect
        name={'seniority'}
        label='Seniority'
        values={props.targetGroupValues?.seniorities}
        selected={props.form.seniority}
        onInputChange={props.onInputChange}
      />
      <TargetGroupSelect
        name={'industry'}
        label='Industry'
        values={props.targetGroupValues?.industries}
        selected={props.form.industry}
        onInputChange={props.onInputChange}
      />
      <TargetGroupSelect
        name={'jobCategory'}
        label='Job Category'
        values={props.targetGroupValues?.jobFunctions}
        selected={props.form.jobCategory}
        onInputChange={props.onInputChange}
      />
    </FormGroup>
  );
}

function MultiLangTargetGroupSelect(props: {
  name: string;
  label: string;
  values: TaxonomyEducationAndSeniorityLevel[];
  selected?: { vonqId: string | number; description: string };
  onInputChange: (
    name: string,
    value: { vonqId: string | number; description: string },
  ) => void;
}) {
  const options = props.values?.map((value) => ({
    value: value.id.toString(),
    label: value.name.find((value) => value.languageCode === 'en_GB').value,
  }));
  const selected = options?.find(
    (option) => option.value === props.selected?.vonqId,
  );

  return (
    <div>
      <label className='form-label'>
        {props.label} <span className='ps-1 text-danger'>*</span>
      </label>
      <Select
        options={options}
        isLoading={options == null}
        selected={selected}
        placeholder={`Select ${props.label}`}
        onChange={(option: SelectOption) =>
          props.onInputChange(
            props.name,
            multiLangTargetGroupFromOption(option),
          )
        }
      />
    </div>
  );
}

function TargetGroupSelect(props: {
  name: string;
  label: string;
  values: { id: number | string; name: string }[];
  selected?: { id: number | string; description: string };
  onInputChange: (
    name: string,
    value: { id?: number | string; description: string },
  ) => void;
}) {
  const options = props.values?.map((value) => ({
    value: value.id.toString(),
    label: value.name,
  }));
  const selected = options?.find(
    (option) => option.label === props.selected?.description,
  );

  return (
    <div>
      <label className='form-label'>
        {props.label} <span className='ps-1 text-danger'>*</span>
      </label>
      <Select
        options={options}
        isLoading={options == null}
        selected={selected}
        placeholder={`Select ${props.label}`}
        onChange={(option: SelectOption) =>
          props.onInputChange(props.name, targetGroupFromOption(option))
        }
      />
    </div>
  );
}
